import React, { useState } from 'react';

const ApplyAllInput = ({
  onApply,
  min = 0,
  defaultValue = '0',
  inputClassName = 'fp-apply-input',
  btnClassName = 'fp-apply-btn'
}) => {
  const [value, setValue] = useState(defaultValue);
  const apply = () => {
    const v = parseFloat(value);
    if (!isNaN(v) && v >= min) onApply(v);
  };
  return (
    <>
      <span className={inputClassName}>
        <input
          type="text"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') apply();
          }}
        />
      </span>
      <button type="button" className={btnClassName} onClick={apply}>
        Apply
      </button>
    </>
  );
};

export default ApplyAllInput;
